import React from 'react';

import { useConfiguration } from '../../../hooks/Configuration';

interface IVideoProps {
    videoId: string
}

function Video({ videoId }: IVideoProps) {
    const configuration = useConfiguration();

    return (
        <div className='stx-media-wrapper'>
            <video controls>
                <source
                    src={`${configuration?.mediaPath}${videoId}`}
                    type="video/mp4" />
                Your browser does not support HTML video.
            </video>
        </div>
    );
}

export default Video;
